export const productFieldArray = [
  { label: 'Product Description', display: 'description', value: 1 },
  { label: 'Supplier', display: 'suppliers', value: 2 },
  { label: 'Brand', display: 'brandId', value: 3 },
  { label: 'Sub Brand', display: 'subBrandId', value: 23 },
  { label: 'Season', display: 'seasonId', value: 4 },
  { label: 'Month', display: 'month', value: 5 },
  { label: 'Year', display: 'year', value: 6 },
  { label: 'Product Type', display: 'supplierType' },
  { label: 'Category 1', display: 'catOneId', value: 7 },
  { label: 'Category 2', display: 'catTwoId', value: 8 },
  { label: 'Category 3', display: 'catThreeId', value: 9 },
  { label: 'Category 4', display: 'catFourId', value: 10 },
];

export const testFieldArray = [
  { label: 'Testing Code', display: 'code', value: 11 },
  { label: 'Testing Description', display: 'description', value: 12 },
  { label: 'Testing Type', display: 'type', value: 13 },
  { label: 'Minimum Pass Rate', display: 'minPassRate', value: 14 },
  { label: 'Component Supplier', display: 'supplier', value: 15 },
  { label: 'BOM Component', display: 'bomComponent', value: 16 },
  { label: 'Colour Ref', display: 'colour', value: 17 },
  { label: 'Additional Info', display: 'additionalInformation', value: 18 },
  { label: 'Test Reports', display: 'testReport', value: 19 },
  { label: 'Test Price', display: 'testPrice', value: 22 },
  { label: 'Expiry Date', display: 'selectedDate', value: 20 },
  { label: 'Test Comment', display: 'comment', value: 21 },
  { label: 'Result/Status', display: 'status', value: 24 },
];

export const mappedArray = [...productFieldArray, ...testFieldArray];

export const excludeOptionsArr = [
  { _id: true, name: 'Testing with reports' },
  { _id: false, name: 'Testing without reports' },
];

export const dateOptions = [
  { name: 'Today', _id: 'today' },
  { name: 'This Week', _id: 'thisWeek' },
  { name: 'This Month', _id: 'thisMonth' },
  { name: 'Custom Dates', _id: 'customDates' },
];

export const statusArr = [
  { _id: 'Approved', name: 'Approved' },
  { _id: 'Rejected', name: 'Rejected' },
  { _id: 'Pending', name: 'Pending' },
];

export const customStyles = {
  option: (provided) => ({
    ...provided,
    padding: '5px 10px',
  }),
  container: () => ({
    // none of react-select's styles are passed to <Control />
    flex: '1',
    minWidth: 200,
    marginRight: 10,
  }),
  control: () => ({
    // none of react-select's styles are passed to <Control />
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    minHeight: '24px',
    height: '24px',
    border: 'none',
    borderBottom: '1px solid #848484',
    borderRadius: 0,
    boxShadow: 'none',
    fontSize: 'var(--16px)',
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  },
  menu: (provided) => ({
    ...provided,
    margin: '-9px 0 0 0',
    border: '1px solid #848484',
    borderRadius: 0,
    padding: 0,
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: 0,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#848484',
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '0 4px',
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: '0 4px',
  }),
};
